<template>
  <div class="flex flex-col w-min mt-auto">
    <label :class="(field.dataType === CustomFieldDataType.BOOLEAN ? 'mx-auto text-center ' : '') + 'font-bold break-words mb-1'">{{
      field.label
    }}</label>
    <InputNumber
      v-if="field.dataType === CustomFieldDataType.NUMERIC"
      v-model="field.numericValue"
      :mode="field.numericFormat === CustomFieldNumericOption.CURRENCY ? 'currency' : 'decimal'"
      currency="USD"
      locale="en-US"
      :maxFractionDigits="field.numericFormat === CustomFieldNumericOption.CURRENCY ? 2 : field.decimals"
      :suffix="field.numericFormat === CustomFieldNumericOption.PERCENT ? '%' : ''"
      allowEmpty
      class="h-10"
      input-class="w-40"
      :disabled="!editing"
    />
    <DatePicker
      v-else-if="field.dataType === CustomFieldDataType.DATE"
      v-model="field.dateTimeValue"
      showIcon
      show-button-bar
      :show-on-focus="false"
      icon-display="button"
      inputId=""
      class="h-10"
      inputClass="w-30"
      panelClass="bg-white dark:bg-surface-700/80 backdrop-blur-xl"
      dateFormat="m/d/yy"
      :disabled="!editing"
    />
    <Select
      v-else-if="field.dataType === CustomFieldDataType.LIST"
      v-model="field.textValue"
      class="h-10"
      input-class="min-w-40"
      :options="field.listValues"
      :disabled="!editing"
    />
    <Checkbox
      v-else-if="field.dataType === CustomFieldDataType.BOOLEAN"
      v-model="field.booleanValue"
      :binary="true"
      class="my-auto h-10 flex items-center justify-center w-20"
      :disabled="!editing"
    ></Checkbox>
    <InputText v-else v-model="field.textValue" class="h-10 min-w-40" :maxlength="field.maxLength" :disabled="!editing" />
  </div>
</template>

<script setup lang="ts">
import { CustomFieldDataType } from "@/enums/CustomFieldDataType";
import { CustomFieldNumericOption } from "@/enums/CustomFieldNumericOption";
import type { FlexRowField } from "@/types/FlexRows";

const field = defineModel<FlexRowField>("field", { required: true });
interface Props {
  editing: boolean;
}
const props = defineProps<Props>();
</script>
